import { Asset } from './asset.model';
import { Brand } from './brand.model';
import { SuperModel } from './super-model.model';

export class Catalog extends SuperModel {
  title: string;
  browsableCatalogUrl: string;
  globalCatalog: boolean;
  previewImage: Asset;
  brand: Brand;

  constructor(data: any = {}) {
    super(data);

    this.title = data.title;
    this.browsableCatalogUrl = data.browsableCatalogUrl;
    this.globalCatalog = data.globalCatalog;

    if (data.previewImage) {
      this.previewImage = new Asset(data.previewImage);
    }
    if (data.brand) {
      this.brand = new Brand(data.brand);
    }
  }

  get serialised() {
    return {
      id: this.id,
      title: this.title,
      browsableCatalogUrl: this.browsableCatalogUrl,
      globalCatalog: this.globalCatalog,
      previewImage: this.previewImage,
      brand: this.brand,
    };
  }
}
